/**
 * Created by mac on 4/8/18
 */

const VideoAds = function () {
    AdsPlugin.call(this, connector.TEST, {
        sdk: SdkManager.SDK_TEST,
        cantLoadAndPlayInParallel: true
    });
    this.bannerProbability = 1;
};

VideoAds.prototype = Object.create(AdsPlugin.prototype);
VideoAds.prototype.constructor = VideoAds;

VideoAds.isAppropriate = function () {
    return connector.platform.oneOf(connector.TEST);
};

VideoAds.prototype.isNoAdsProductAvailable = function () {
    return true;
};

VideoAds.prototype.isStickySupported = function () {
    return true;
};

VideoAds.prototype.isStickyAvailable = function () {
    return true;
};

VideoAds.prototype._connect = function (callback) {
    setTimeout(() => {
        callback(connector.STATUS_CONNECTED);
    }, 1000);
};

VideoAds.prototype.isInterstitialSupported = function () {
    return true;
};

VideoAds.prototype.isRewardedSupported = function () {
    return true;
};

VideoAds.prototype._cacheAd = function (name, callback) {
    if (name === AdsPlugin.INTERSTITIAL) {
        setTimeout(() => callback(connector.CODE_SUCCEED, true), 0);
        return;
    }

    setTimeout(() => {
        let adFunc;
        const adBreakDone = (code) => {
            this._rewardedCallback(code);
            delete this._rewardedCallback;
        };

        if (this._rewardedCallback) {
            console.error("New ad cached while current is running");
            adFunc = () => {
                console.error("Discarded ad cached during other ad playing");
                adBreakDone(ERRORS.SHOW_REWARDED.AD_ALREADY_RUNNING);
            };
        } else {
            adFunc = (name) => {
                setTimeout(() => this._createAdOverlay(name, adBreakDone), 0);
            };
        }

        callback(connector.CODE_SUCCEED, adFunc);
    }, 0);
};

VideoAds.prototype._playAd = function (name, ad, callback) {
    if (name === AdsPlugin.INTERSTITIAL) {
        setTimeout(() => this._createAdOverlay(name, callback), 0);
        return;
    }

    this._rewardedCallback = callback;
    ad(name);
};

VideoAds.prototype.setBannerProbability = function (probability) {
    this.bannerProbability = probability;
};

VideoAds.prototype.setBannerSize = function (bannerSize) {
    this.bannerSize = bannerSize;
};

VideoAds.prototype.setRewardedDuration = function (duration) {
    this.rewardedDuration = duration;
};

VideoAds.prototype.showSticky = function (callback) {
    const prob = this.bannerProbability || 0.3;
    if (Math.random() > prob) {
        callback && callback(ERRORS.SHOW_STICKY.NO_STICKY);
        return;
    }
    this.closeSticky();

    const isInIframe = window.top !== window.self;
    const scale = isInIframe ? Math.min(1, window.innerHeight / 600) : 1;
    const bannerSize = this.bannerSize || {
        width: Math.min(Math.round(728 * scale), Math.round(window.innerWidth * 0.95)),
        height: Math.round(90 * scale)
    };

    const banner = this.banner = document.createElement("div");
    document.body.appendChild(banner);
    banner.style.width = `${bannerSize.width}px`;
    banner.style.height = `${bannerSize.height}px`;
    banner.style.position = "absolute";
    banner.style.bottom = "0px";
    banner.style.left = "50%";
    banner.style.marginLeft = `${-bannerSize.width / 2}px`;
    banner.style.backgroundImage = "url(https://pay.zareefgaming.com/example/banner_bg.png)";
    banner.style.backgroundSize = "cover";
    banner.style.backgroundPosition = "center";
    banner.style.zIndex = "10";
    banner.style.fontFamily = "Consolas, monospace";
    banner.style.overflow = "hidden";

    banner.style.display = "grid";
    banner.style.gridTemplateColumns = "20% 60% 20%";

    const iconContainer = document.createElement("div");
    iconContainer.style.display = "flex";
    iconContainer.style.alignItems = "center";
    iconContainer.style.justifyContent = "center";
    banner.appendChild(iconContainer);

    const icon = document.createElement("img");
    icon.src = "https://pay.zareefgaming.com/example/banner_icon.png";
    icon.style.maxHeight = `${bannerSize.height - 10}px`;
    icon.style.maxWidth = "100%";
    iconContainer.appendChild(icon);

    const textContainer = document.createElement("div");
    textContainer.style.display = "flex";
    textContainer.style.alignItems = "center";
    textContainer.style.justifyContent = "center";
    textContainer.style.overflow = "hidden";
    textContainer.style.textAlign = "center";
    banner.appendChild(textContainer);

    const text = document.createElement("div");
    text.innerText = `This is a ${bannerSize.width}x${bannerSize.height} test ad.`;
    text.style.color = "#001F3F";
    text.style.whiteSpace = "nowrap";
    textContainer.appendChild(text);

    const rightContainer = document.createElement("div");
    banner.appendChild(rightContainer);

    const initialFontSize = Math.floor(bannerSize.height * 0.27);
    const minFontSize = 10;
    text.style.fontSize = `${initialFontSize}px`;

    const containerWidth = textContainer.clientWidth;
    const textWidth = text.scrollWidth;

    if (textWidth > containerWidth) {
        let newFontSize = Math.floor(initialFontSize * containerWidth / textWidth);
        newFontSize = Math.max(newFontSize, minFontSize);
        text.style.fontSize = `${newFontSize}px`;
    }

    callback && callback(connector.CODE_SUCCEED, bannerSize);
};

VideoAds.prototype.closeSticky = function (callback) {
    if (this.banner) {
        document.body.removeChild(this.banner);
        delete this.banner;
    }

    callback && callback(connector.CODE_SUCCEED);
};

VideoAds.prototype._createAdOverlay = function (name, callback) {
    const duration = (name === AdsPlugin.REWARDED && this.rewardedDuration) || (name === AdsPlugin.INTERSTITIAL ? VideoAds.INTERSTITIAL_DURATION : 3000);

    const styles = document.createElement("style");
    styles.innerHTML = ".video-ads-overlay {"
        + "  position: fixed;"
        + "  top: 0;"
        + "  right: 0;"
        + "  bottom: 0;"
        + "  left: 0;"
        + "  background: linear-gradient(135deg, rgba(0, 0, 0, 0.6), rgba(20, 20, 20, 0.6));"
        + "  z-index: 1000;"
        + "  display: flex;"
        + "  flex-direction: column;"
        + "  justify-content: center;"
        + "  align-items: center;"
        + "  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;"
        + "  color: #fff;"
        + "}"
        + ".video-ads-type {"
        + "  font-size: 2.5em;"
        + "  font-weight: bold;"
        + "  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);"
        + "  margin-bottom: 20px;"
        + "}"
        + ".video-ads-skip {"
        + "  font-size: 1.5em;"
        + "  padding: 10px 20px;"
        + "  background: rgba(0, 0, 0, 0.7);"
        + "  border: none;"
        + "  border-radius: 8px;"
        + "  color: #fff;"
        + "  cursor: pointer;"
        + "}"
        + ".video-ads-card {"
        + "  position: relative;"
        + "  width: 90%;"
        + "  max-width: 420px;"
        + "  box-sizing: border-box;"
        + "  padding: 36px 20px 20px;"
        + "  border-radius: 8px;"
        + "  background: #fff;"
        + "  color: #333;"
        + "  text-align: center;"
        + "}"
        + ".video-ads-card .video-ads-type {"
        + "  font-size: 1.5em;"
        + "  text-shadow: none;"
        + "}"
        + ".video-ads-close {"
        + "  position: absolute;"
        + "  top: 4px;"
        + "  right: 4px;"
        + "  width: 32px;"
        + "  height: 32px;"
        + "  padding: 0;"
        + "  line-height: 32px;"
        + "  background: transparent;"
        + "  border: none;"
        + "  font-size: 24px;"
        + "  color: #666;"
        + "  cursor: pointer;"
        + "}"
        + ".video-ads-close:hover {"
        + "  color: #000;"
        + "}"
        + ".video-ads-progress-row {"
        + "  display: flex;"
        + "  align-items: center;"
        + "}"
        + ".video-ads-progress {"
        + "  flex: 1 1 auto;"
        + "  height: 8px;"
        + "  border-radius: 4px;"
        + "  background: #e0e0e0;"
        + "  overflow: hidden;"
        + "}"
        + ".video-ads-progress-bar {"
        + "  width: 0;"
        + "  height: 100%;"
        + "  background: #1E7E34;"
        + `  animation: video-ads-progress ${duration}ms linear forwards;`
        + "}"
        + "@keyframes video-ads-progress {"
        + "  to { width: 100%; }"
        + "}"
        + ".video-ads-timer {"
        + "  flex: none;"
        + "  margin-left: 10px;"
        + "  min-width: 4em;"
        + "  text-align: right;"
        + "  font-size: 14px;"
        + "  color: #666;"
        + "  font-variant-numeric: tabular-nums;"
        + "  white-space: nowrap;"
        + "}"
        + ".video-ads-interstitial {"
        + "  background: #202124;"
        + "}"
        + ".video-ads-topbar {"
        + "  position: absolute;"
        + "  top: 0;"
        + "  left: 0;"
        + "  right: 0;"
        + "  display: flex;"
        + "  justify-content: space-between;"
        + "  align-items: center;"
        + "  padding: 12px 16px;"
        + "  font-size: 14px;"
        + "}"
        + ".video-ads-badge {"
        + "  display: inline-block;"
        + "  margin-right: 8px;"
        + "  padding: 1px 6px;"
        + "  border-radius: 3px;"
        + "  background: #fbbc04;"
        + "  color: #202124;"
        + "  font-weight: bold;"
        + "}"
        + ".video-ads-skip-button {"
        + "  padding: 8px 14px;"
        + "  border: 1px solid rgba(255, 255, 255, 0.5);"
        + "  border-radius: 4px;"
        + "  background: rgba(0, 0, 0, 0.6);"
        + "  color: #fff;"
        + "  font-size: 14px;"
        + "  cursor: default;"
        + "  opacity: 0.7;"
        + "}"
        + ".video-ads-skip-button.ready {"
        + "  cursor: pointer;"
        + "  opacity: 1;"
        + "}"
        + ".video-ads-creative {"
        + "  width: 85%;"
        + "  max-width: 360px;"
        + "  border-radius: 12px;"
        + "  overflow: hidden;"
        + "  background: #fff;"
        + "  color: #202124;"
        + "  text-align: center;"
        + "  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);"
        + "}"
        + ".video-ads-creative-image {"
        + "  height: 180px;"
        + "  display: flex;"
        + "  justify-content: center;"
        + "  align-items: center;"
        + "  background: linear-gradient(135deg, #4285f4, #34a853 50%, #fbbc04);"
        + "  color: #fff;"
        + "  font-size: 28px;"
        + "  font-weight: bold;"
        + "  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.4);"
        + "}"
        + ".video-ads-creative-text {"
        + "  padding: 16px 20px 6px;"
        + "  font-size: 15px;"
        + "  color: #5f6368;"
        + "}"
        + ".video-ads-cta {"
        + "  margin: 12px 0 20px;"
        + "  padding: 10px 32px;"
        + "  border: none;"
        + "  border-radius: 20px;"
        + "  background: #1a73e8;"
        + "  color: #fff;"
        + "  font-size: 15px;"
        + "  font-weight: bold;"
        + "}"
        + ".video-ads-bottom-progress {"
        + "  position: absolute;"
        + "  left: 0;"
        + "  right: 0;"
        + "  bottom: 0;"
        + "  height: 4px;"
        + "  background: rgba(255, 255, 255, 0.25);"
        + "}"
        + ".video-ads-bottom-progress .video-ads-progress-bar {"
        + "  background: #fbbc04;"
        + "}";
    document.head.appendChild(styles);

    const overlay = document.createElement("div");
    overlay.className = "video-ads-overlay";
    document.body.appendChild(overlay);
    this.bus.trigger("updateFrameSize");

    let adTypeText = "";
    if (name === AdsPlugin.INTERSTITIAL) {
        adTypeText = "Interstitial Ad";
    } else if (name === AdsPlugin.REWARDED) {
        adTypeText = "Rewarded Ad";
    } else {
        adTypeText = `${name} Ad`;
    }

    const type = document.createElement("div");
    type.innerText = `${adTypeText} is playing`; 
    type.className = "video-ads-type";

    const cancel = () => {
        stop(name === AdsPlugin.INTERSTITIAL ? ERRORS.SHOW_INTERSTITIAL.CLOSED_BY_USER : ERRORS.SHOW_REWARDED.CLOSED_BY_USER);
    };

    let timerTimeout;

    if (name === AdsPlugin.REWARDED) {
        const card = document.createElement("div");
        card.className = "video-ads-card";
        overlay.appendChild(card);

        const close = document.createElement("button");
        close.innerHTML = "&times;";
        close.className = "video-ads-close";
        close.onclick = cancel;
        card.appendChild(close);

        card.appendChild(type);

        const row = document.createElement("div");
        row.className = "video-ads-progress-row";
        card.appendChild(row);

        const progress = document.createElement("div");
        progress.className = "video-ads-progress";
        row.appendChild(progress);

        const bar = document.createElement("div");
        bar.className = "video-ads-progress-bar";
        progress.appendChild(bar);

        const timer = document.createElement("div");
        timer.className = "video-ads-timer";
        row.appendChild(timer);

        const start = Date.now();
        const tick = () => {
            timer.innerText = `${Math.floor((Date.now() - start) / 1000)} / ${duration / 1000} s`;
            timerTimeout = setTimeout(tick, 250);
        };
        tick();
    } else if (name === AdsPlugin.INTERSTITIAL) {
        // looks like a Google full-screen ad: an Ad badge with the time left, a skip button after a countdown,
        // a creative card and a progress bar running along the bottom
        overlay.classList.add("video-ads-interstitial");

        const topbar = document.createElement("div");
        topbar.className = "video-ads-topbar";
        overlay.appendChild(topbar);

        const info = document.createElement("div");
        topbar.appendChild(info);

        const skip = document.createElement("button");
        skip.className = "video-ads-skip-button";
        topbar.appendChild(skip);

        const creative = document.createElement("div");
        creative.className = "video-ads-creative";
        creative.innerHTML = "<div class='video-ads-creative-image'>Test Ad</div>"
            + "<div class='video-ads-creative-text'>This is a test interstitial ad.</div>"
            + "<button class='video-ads-cta'>Install</button>";
        overlay.appendChild(creative);

        const progress = document.createElement("div");
        progress.className = "video-ads-bottom-progress";
        overlay.appendChild(progress);

        const bar = document.createElement("div");
        bar.className = "video-ads-progress-bar";
        progress.appendChild(bar);

        const start = Date.now();
        const tick = () => {
            const elapsed = Date.now() - start;
            const left = Math.max(0, Math.ceil((duration - elapsed) / 1000));
            info.innerHTML = `<span class='video-ads-badge'>Ad</span>0:${String(left).padStart(2, "0")} · Esc to close`;

            const skipIn = Math.ceil((VideoAds.INTERSTITIAL_SKIP_AFTER - elapsed) / 1000);
            if (skipIn > 0) {
                skip.innerText = `Skip in ${skipIn}`;
            } else if (!skip.onclick) {
                skip.innerText = "Skip Ad ▸";
                skip.classList.add("ready");
                skip.onclick = cancel;
            }
            timerTimeout = setTimeout(tick, 250);
        };
        tick();
    } else {
        overlay.appendChild(type);

        const skip = document.createElement("button");
        skip.innerText = "Tap Anywhere to Skip";
        skip.className = "video-ads-skip";
        overlay.appendChild(skip);

        overlay.onclick = cancel;
    }

    // Esc closes the ad; caught on the window before the game's own key handlers so the game does not react to it too
    const handleEscape = (event) => {
        if (event.key === "Escape" || event.keyCode === 27) {
            event.stopPropagation();
            event.preventDefault();
            if (event.type === "keydown") {
                cancel();
            }
        }
    };
    window.addEventListener("keydown", handleEscape, true);
    window.addEventListener("keyup", handleEscape, true);

    const stop = connector.utils.once((code) => {
        clearTimeout(rewardTimeout);
        clearTimeout(timerTimeout);
        if (overlay.parentNode) {
            document.body.removeChild(overlay);
        }
        if (styles.parentNode) {
            document.head.removeChild(styles);
        }
        window.removeEventListener("keydown", handleEscape, true);
        // the release of the Esc that closed the ad comes after it is gone
        setTimeout(() => window.removeEventListener("keyup", handleEscape, true), 500);
        callback(code);

        this.bus.trigger("updateFrameSize");
    });

    const rewardTimeout = setTimeout(() => stop(connector.CODE_SUCCEED), duration);
};

VideoAds.INTERSTITIAL_DURATION = 5000;
VideoAds.INTERSTITIAL_SKIP_AFTER = 3000;
